import { render } from "./nginx-sites.vue?vue&type=template&id=46368192&scoped=true"
import script from "./nginx-sites.vue?vue&type=script&lang=js"
export * from "./nginx-sites.vue?vue&type=script&lang=js"

import "./nginx-sites.vue?vue&type=style&index=0&id=46368192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46368192"]])

export default __exports__